import { v4 as uuid } from 'uuid';
var ɵ0 = uuid();
export var defaultCriteriaGroup = {
    id: ɵ0,
    name: 'Todos os critérios',
    criterias: [
        {
            ruleName: 'accepted_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'refused_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'completed_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'incompleted_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'average_rating',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'response_on_time_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'solution_on_time_percentage',
            value: {
                points: 100
            }
        },
        {
            ruleName: 'requested_interval',
            value: {
                resultThreshold: 24,
                points: 100
            },
        },
        {
            ruleName: 'on_negotiation_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'pending_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'scheduled_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'in_progress_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'reported_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'response_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'solution_interval',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'average_response_time_in_days',
            value: {
                resultThreshold: 24,
                points: 100
            }
        },
        {
            ruleName: 'average_close_time_in_days',
            value: {
                resultThreshold: 24,
                points: 100
            }
        }
    ]
};
export { ɵ0 };
